export default __webpack_public_path__ + "static/media/our-motivation-mobile.38fe2078.svg";